import React, { useState, useMemo } from 'react';

/* External */
import { connect, useSelector } from 'react-redux';
import { compose } from 'redux';
import {
  AssignmentOutlined,
  HouseOutlined,
  AssignmentIndOutlined,
  CalendarTodayOutlined,
  LayersOutlined,
} from '@material-ui/icons';
import { Box, Link } from '@material-ui/core';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

/* Project */
import { TruncateTextToolTip } from 'commons/components/DataTable/TruncateTextToolTip';
import { appActions } from 'commons/reducer';
import { Row } from 'commons/components/DataTable/Row';
import { TruncateText } from 'commons/components/DataTable/TruncateText';
import { clone } from 'utils/functions';
import { selectState, actionProps } from 'utils/reduxActions';
import Paths from 'utils/paths';
import connectSaga from 'utils/saga';
import ItemMenu from '../ItemMenu';
import saga from '../../../../saga';
import { dispatchesActions } from '../../../../reducer';
import { getAccessPolicy, getCurrentSubdomain } from 'utils/accessPolicy';
import './styles.css';

function Item(props) {
  const { t } = useTranslation();
  const {
    cDispatch: dispatch,
    objects,
    clients,
    actions,
    headerList,
    isMobileDevice,
    suppliers,
    history,
  } = props;

  const account = useSelector((state) => state.app.account);
  const device = useSelector((state) => state.app.device);
  const role = useSelector((state) => state.app.role);
  const accessPolicy = getAccessPolicy({
    subdomain: getCurrentSubdomain(),
    roleName: role?.name,
  });
  const { canDelete, canPrint, canViewDetail } = accessPolicy.dispatches;

  const itemResources = useMemo(() => {
    const clientsName = clients.find((c) => c.id === dispatch.client().id)?.name;
    const dispatchNumber = dispatch.number;
    const date = moment(dispatch.process().date).format('DD-MM-YYYY');

    const lots = dispatch.lots();
    const lotNumbers = [...new Set(lots.map((l) => l.lotNumbers()).flat())].sort((a, b) => a - b);
    const receipts = [...new Set(lots.map((l) => l.originReceipts()).flat())];
    const supplierIds = [...new Set(receipts.map((r) => r.supplierId))];
    const suppliersNames = suppliers
      .filter((s) => supplierIds.includes(s.id))
      .map((s) => s.name)
      .join(', ');

    return {
      lots,
      lotNumbers,
      suppliersNames,
      date,
      dispatchNumber,
      clientsName,
    };
  }, [dispatch]);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.target);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleDelete = () => {
    handleClose();
    actions.toggleDelete(anchorEl.dataset.id);
  };

  const toggleEdit = (id) => {
    handleClose();
    const item = Object.values(objects.dispatches).find(
      (itemIt) => itemIt.id === Number(id || anchorEl.dataset.id),
    );

    const process = Object.values(objects.processes).find((p) => p.id === item.processId);
    item.date = process.date;

    const lots = Object.values(objects.lots).filter(
      (lot) => lot.destinyProcessId === item.processId,
    );

    actions.toggleEdit(item, lots);
  };

  const printFnc = () => {
    const labelData = { lotIds: dispatch.lots().map((l) => l.id), accountId: account?.id };
    actions.printLabel(device, labelData);
  };

  const getOptions = () => (
    <ItemMenu
      anchorEl={anchorEl}
      cDispatch={dispatch}
      handleClick={(e) => {
        e.stopPropagation();
        handleClick(e);
      }}
      handleClose={(e) => {
        e.stopPropagation();
        handleClose(e);
      }}
      toggleDelete={toggleDelete}
      toggleEdit={toggleEdit}
      printFnc={printFnc}
      canDelete={canDelete}
      canPrint={canPrint}
    />
  );

  const linkToReception = (lotNumbers, text) => (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      style={{ cursor: 'pointer' }}
      onClick={(evt) => {
        evt.stopPropagation();
        history.push(`${Paths.RECEIPTS}?lotNumber=${lotNumbers.join(',')}`);
      }}>
      {text}
    </Link>
  );

  const lotNumbersList = (lotNumbers) => {
    const MAX_LOT_NUMBERS = 3;
    if (lotNumbers.length > MAX_LOT_NUMBERS) {
      const lotNumberText = `${lotNumbers.slice(0, MAX_LOT_NUMBERS).join(', ')}... `;
      return (
        <>
          {lotNumberText}
          {linkToReception(lotNumbers, t('See more'))}
        </>
      );
    }

    return <>{linkToReception(lotNumbers, lotNumbers.join(', '))}</>;
  };

  const itemRow = [
    {
      value: `#${itemResources.dispatchNumber}`,
      icon: <AssignmentOutlined />,
    },
    {
      value: lotNumbersList(itemResources.lotNumbers),
      // value: '-',
      icon: <LayersOutlined />,
    },
    {
      // value: '-',
      value: <TruncateTextToolTip lines={3} text={itemResources.suppliersNames} />,
      icon: <HouseOutlined />,
    },
    {
      value: <TruncateText lines={2} text={itemResources.clientsName} />,
      icon: <AssignmentIndOutlined />,
    },
    {
      value: itemResources.date,
      icon: <CalendarTodayOutlined />,
    },
    {
      value: <Box className="row-options">{getOptions()}</Box>,
    },
  ];

  return (
    <Row
      row={itemRow}
      headerList={headerList}
      handleOnClick={canViewDetail ? () => toggleEdit(dispatch.id) : undefined}
      isMobileDevice={isMobileDevice}
    />
  );
}

const withSaga = connectSaga({ key: 'sagaDispatches', saga });

const withConnect = connect(
  selectState('app.account', 'app.device'),
  actionProps(
    clone(clone.OBJECT, {
      printLabel: appActions.printLabel,
      toggleEdit: dispatchesActions.toggleEdit,
      toggleDelete: dispatchesActions.toggleDelete,
    }),
  ),
);

export default compose(withRouter, withConnect)(withSaga(Item));
